import {
	AdminIcon as NewAdminIcon,
	AdminLogoCS as NewAdminLogo,
} from './artifacts/logo-components/admin';
import {
	AlignIcon as NewAlignIcon,
	AlignLogoCS as NewAlignLogo,
} from './artifacts/logo-components/align';
import {
	AnalyticsIcon as NewAnalyticsIcon,
	AnalyticsLogoCS as NewAnalyticsLogo,
} from './artifacts/logo-components/analytics';
import {
	AssetsIcon as NewAssetsIcon,
	AssetsLogoCS as NewAssetsLogo,
} from './artifacts/logo-components/assets';
import {
	BambooIcon as NewBambooIcon,
	BambooLogoCS as NewBambooLogo,
} from './artifacts/logo-components/bamboo';
import {
	BitbucketIcon as NewBitbucketIcon,
	BitbucketLogoCS as NewBitbucketLogo,
} from './artifacts/logo-components/bitbucket';
import {
	BitbucketDataCenterIcon as NewBitbucketDataCenterIcon,
	BitbucketDataCenterLogoCS as NewBitbucketDataCenterLogo,
} from './artifacts/logo-components/bitbucket-data-center';
import {
	ChatIcon as NewChatIcon,
	ChatLogoCS as NewChatLogo,
} from './artifacts/logo-components/chat';
import {
	CompassIcon as NewCompassIcon,
	CompassLogoCS as NewCompassLogo,
} from './artifacts/logo-components/compass';
import {
	ConfluenceIcon as NewConfluenceIcon,
	ConfluenceLogoCS as NewConfluenceLogo,
} from './artifacts/logo-components/confluence';
import {
	ConfluenceDataCenterIcon as NewConfluenceDataCenterIcon,
	ConfluenceDataCenterLogoCS as NewConfluenceDataCenterLogo,
} from './artifacts/logo-components/confluence-data-center';
import {
	CrowdIcon as NewCrowdIcon,
	CrowdLogoCS as NewCrowdLogo,
} from './artifacts/logo-components/crowd';
import {
	CustomerServiceManagementIcon as NewCustomerServiceManagementIcon,
	CustomerServiceManagementLogoCS as NewCustomerServiceManagementLogo,
} from './artifacts/logo-components/customer-service-management';
import { DxIcon as NewDXIcon } from './artifacts/logo-components/dx';
import {
	FeedbackIcon as NewFeedbackIcon,
	FeedbackLogoCS as NewFeedbackLogo,
} from './artifacts/logo-components/feedback';
import {
	FocusIcon as NewFocusIcon,
	FocusLogoCS as NewFocusLogo,
} from './artifacts/logo-components/focus';
import {
	GoalsIcon as NewGoalsIcon,
	GoalsLogoCS as NewGoalsLogo,
} from './artifacts/logo-components/goals';
import {
	GuardIcon as NewGuardIcon,
	GuardLogoCS as NewGuardLogo,
} from './artifacts/logo-components/guard';
import {
	HomeIcon as NewHomeIcon,
	HomeLogoCS as NewHomeLogo,
} from './artifacts/logo-components/home';
import { HubIcon as NewHubIcon, HubLogoCS as NewHubLogo } from './artifacts/logo-components/hub';
import {
	JiraIcon as NewJiraIcon,
	JiraLogoCS as NewJiraLogo,
} from './artifacts/logo-components/jira';
import {
	JiraDataCenterIcon as NewJiraDataCenterIcon,
	JiraDataCenterLogoCS as NewJiraDataCenterLogo,
} from './artifacts/logo-components/jira-data-center';
import {
	JiraProductDiscoveryIcon as NewJPDIcon,
	JiraProductDiscoveryLogoCS as NewJPDLogo,
} from './artifacts/logo-components/jira-product-discovery';
import {
	JiraServiceManagementIcon as NewJSMIcon,
	JiraServiceManagementLogoCS as NewJSMLogo,
} from './artifacts/logo-components/jira-service-management';
import {
	JiraServiceManagementDataCenterIcon as NewJiraServiceManagementDataCenterIcon,
	JiraServiceManagementDataCenterLogoCS as NewJiraServiceManagementDataCenterLogo,
} from './artifacts/logo-components/jira-service-management-data-center';
import {
	LoomIcon as NewLoomIcon,
	LoomLogoCS as NewLoomLogo,
} from './artifacts/logo-components/loom';
import { LoomAttributionLogoCS as NewLoomAttributionLogo } from './artifacts/logo-components/loom-attribution';
import {
	LoomInternalIcon as NewLoomInternalIcon,
	LoomInternalLogoCS as NewLoomInternalLogo,
} from './artifacts/logo-components/loom-internal';
import {
	OpsgenieIcon as NewOpsgenieIcon,
	OpsgenieLogoCS as NewOpsgenieLogo,
} from './artifacts/logo-components/opsgenie';
import {
	ProjectsIcon as NewProjectsIcon,
	ProjectsLogoCS as NewProjectsLogo,
} from './artifacts/logo-components/projects';
import {
	RovoIcon as NewRovoIcon,
	RovoLogoCS as NewRovoLogo,
} from './artifacts/logo-components/rovo';
import {
	RovoDevIcon as NewRovoDevIcon,
	RovoDevLogoCS as NewRovoDevLogo,
} from './artifacts/logo-components/rovo-dev';
import {
	RovoDevAgentIcon as NewRovoDevAgentIcon,
	RovoDevAgentLogoCS as NewRovoDevAgentLogo,
} from './artifacts/logo-components/rovo-dev-agent';
import {
	RovoHexIcon as NewRovoHexIcon,
	RovoHexLogoCS as NewRovoHexLogo,
} from './artifacts/logo-components/rovo-hex';
import {
	SearchIcon as SearchNewIcon,
	SearchLogoCS as SearchNewLogoCS,
} from './artifacts/logo-components/search';
import {
	StatuspageIcon as NewStatuspageIcon,
	StatuspageLogoCS as NewStatuspageLogo,
} from './artifacts/logo-components/statuspage';
import {
	StudioIcon as StudioNewIcon,
	StudioLogoCS as StudioNewLogoCS,
} from './artifacts/logo-components/studio';
import {
	TalentIcon as NewTalentIcon,
	TalentLogoCS as NewTalentLogo,
} from './artifacts/logo-components/talent';
import {
	TeamsIcon as NewTeamsIcon,
	TeamsLogoCS as NewTeamsLogo,
} from './artifacts/logo-components/teams';
import {
	TrelloIcon as NewTrelloIcon,
	TrelloLogoCS as NewTrelloLogo,
} from './artifacts/logo-components/trello';
import { createFeatureFlaggedComponent } from './create-feature-flagged-component';
import { createFeatureFlaggedServiceCollectionComponent } from './create-feature-flagged-service-collection-component';
import {
	AtlassianAdminIcon as LegacyAtlassianAdminIcon,
	AtlassianAdminLogo as LegacyAtlassianAdminLogo,
} from './legacy-logos/atlassian-admin';
import {
	AtlassianAdministrationIcon as LegacyAtlassianAdministrationIcon,
	AtlassianAdministrationLogo as LegacyAtlassianAdministrationLogo,
} from './legacy-logos/atlassian-administration';
import {
	AtlassianAnalyticsIcon as LegacyAtlassianAnalyticsIcon,
	AtlassianAnalyticsLogo as LegacyAtlassianAnalyticsLogo,
} from './legacy-logos/atlassian-analytics';
import {
	BitbucketIcon as LegacyBitbucketIcon,
	BitbucketLogo as LegacyBitbucketLogo,
} from './legacy-logos/bitbucket';
import {
	CompassIcon as LegacyCompassIcon,
	CompassLogo as LegacyCompassLogo,
} from './legacy-logos/compass';
import {
	ConfluenceIcon as LegacyConfluenceIcon,
	ConfluenceLogo as LegacyConfluenceLogo,
} from './legacy-logos/confluence';
import { FocusIcon as LegacyFocusIcon, FocusLogo as LegacyFocusLogo } from './legacy-logos/focus';
import { GuardIcon as LegacyGuardIcon, GuardLogo as LegacyGuardLogo } from './legacy-logos/guard';
import { JiraIcon as LegacyJiraIcon, JiraLogo as LegacyJiraLogo } from './legacy-logos/jira';
import {
	JiraAlignIcon as LegacyJiraAlignIcon,
	JiraAlignLogo as LegacyJiraAlignLogo,
} from './legacy-logos/jira-align';
import {
	JiraProductDiscoveryIcon as LegacyJPDIcon,
	JiraProductDiscoveryLogo as LegacyJPDLogo,
} from './legacy-logos/jira-product-discovery';
import {
	JiraServiceManagementIcon as LegacyJSMIcon,
	JiraServiceManagementLogo as LegacyJSMLogo,
} from './legacy-logos/jira-service-management';
import { LoomIcon as LegacyLoomIcon, LoomLogo as LegacyLoomLogo } from './legacy-logos/loom';
import {
	LoomAttributionIcon as LegacyLoomAttributionIcon,
	LoomAttributionLogo as LegacyLoomAttributionLogo,
} from './legacy-logos/loom-attribution';
import {
	OpsgenieIcon as LegacyOpsgenieIcon,
	OpsgenieLogo as LegacyOpsgenieLogo,
} from './legacy-logos/opsgenie';
import { RovoIcon as LegacyRovoIcon, RovoLogo as LegacyRovoLogo } from './legacy-logos/rovo';
import {
	StatuspageIcon as LegacyStatuspageIcon,
	StatuspageLogo as LegacyStatuspageLogo,
} from './legacy-logos/statuspage';
import {
	TrelloIcon as LegacyTrelloIcon,
	TrelloLogo as LegacyTrelloLogo,
} from './legacy-logos/trello';
export { AtlasIcon, AtlasLogo } from './legacy-logos/atlas';
export {
	AtlassianMarketplaceIcon,
	AtlassianMarketplaceLogo,
} from './legacy-logos/atlassian-marketplace';
export { AtlassianAccessIcon, AtlassianAccessLogo } from './legacy-logos/atlassian-access';
export {
	JiraWorkManagementLogo,
	JiraWorkManagementIcon,
} from './legacy-logos/jira-work-management';
export { AtlassianIcon, AtlassianLogo } from './legacy-logos/atlassian';
export { JiraSoftwareIcon, JiraSoftwareLogo } from './legacy-logos/jira-software';
import { createFeatureFlaggedRovoComponent } from './logo-config';
import { tempSizeWrapper } from './temp-size-wrapper';

/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AdminIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAdminIcon);
/**
 * __Admin logo__
 *
 * The Admin logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AdminLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAdminLogo);

/**
 * __Analytics icon__
 *
 * The Analytics icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AnalyticsIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAnalyticsIcon);
/**
 * __Analytics logo__
 *
 * The Analytics logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AnalyticsLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAnalyticsLogo);

/**
 * __Assets icon__
 *
 * The Assets icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AssetsIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAssetsIcon);
/**
 * __Assets logo__
 *
 * The Assets logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AssetsLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAssetsLogo);
/**
 * __Chat icon__
 *
 * The Chat icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const ChatIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewChatIcon);
/**
 * __Chat logo__
 *
 * The Chat logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const ChatLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewChatLogo);
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const CustomerServiceManagementIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(
	NewCustomerServiceManagementIcon,
);
/**
 * __Customer Service Management logo__
 *
 * The Customer service management logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const CustomerServiceManagementLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(
	NewCustomerServiceManagementLogo,
);
/**
 * __Feedback icon__
 *
 * The Feedback icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const FeedbackIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewFeedbackIcon);
/**
 * Feedback logo__
 *
 * The Feedback logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const FeedbackLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewFeedbackLogo);
/**
 * __Goals icon__
 *
 * The Goals icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const GoalsIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewGoalsIcon);
/**
 * __Goals logo__
 *
 * The Goals logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const GoalsLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewGoalsLogo);
/**
 * __Home icon__
 *
 * The Home icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const HomeIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewHomeIcon);
/**
 * __Home logo__
 *
 * The Home logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const HomeLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewHomeLogo);
/**
 * __Hub icon
 *
 * The Hub icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const HubIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewHubIcon);
/**
 * Hub logo__
 *
 * The Hub logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const HubLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewHubLogo);
/**
 * __Projects icon__
 *
 * The Projects icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const ProjectsIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewProjectsIcon);
/**
 * __Projects logo__
 *
 * The Projects logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const ProjectsLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewProjectsLogo);
/**
 * __Rovo Dev icon__
 *
 * The Rovo Dev icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const RovoDevIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewRovoDevIcon);
/**
 * __Rovo Dev logo__
 *
 * The Rovo Dev logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const RovoDevLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewRovoDevLogo);
/**
 * __Rovo Dev Agent icon__
 *
 * The Rovo Dev Agent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const RovoDevAgentIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewRovoDevAgentIcon);
/**
 * __Rovo Dev Agent logo__
 *
 * The Rovo Dev Agent logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const RovoDevAgentLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewRovoDevAgentLogo);
/**
 * __Search icon__
 *
 * The Search icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const SearchIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(SearchNewIcon);
/**
 * __Search logo__
 *
 * The Search logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const SearchLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(SearchNewLogoCS);
/**
 * __Studio icon__
 *
 * The Studio icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const StudioIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(StudioNewIcon);
/**
 * __Studio logo__
 *
 * The Studio logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const StudioLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(StudioNewLogoCS);
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const TalentIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewTalentIcon);
/**
 * __Talent logo__
 *
 * The Talent logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const TalentLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewTalentLogo);
/**
 * __Teams icon__
 *
 * The Teams icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const TeamsIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewTeamsIcon);
/**
 * __Teams logo__
 *
 * The Teams logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const TeamsLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewTeamsLogo);
/**
 * __Bamboo icon__
 *
 * The Bamboo icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const BambooIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewBambooIcon);
/**
 * __Bamboo logo__
 *
 * The Bamboo logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const BambooLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewBambooLogo);
/**
 * __Bitbucket Data Center icon__
 *
 * The Bitbucket Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const BitbucketDataCenterIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewBitbucketDataCenterIcon);
/**
 * __Bitbucket Data Center logo__
 *
 * The Bitbucket Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const BitbucketDataCenterLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewBitbucketDataCenterLogo);
/**
 * __Confluence Data Center icon__
 *
 * The Confluence Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const ConfluenceDataCenterIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewConfluenceDataCenterIcon);
/**
 * __Confluence Data Center logo__
 *
 * The Confluence Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const ConfluenceDataCenterLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewConfluenceDataCenterLogo);
/**
 * __Crowd icon__
 *
 * The Crowd icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const CrowdIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewCrowdIcon);
/**
 * __Crowd logo__
 *
 * The Crowd logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const CrowdLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewCrowdLogo);

/**
 * __Jira Data Center icon__
 *
 * The Jira Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const JiraDataCenterIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewJiraDataCenterIcon);
/**
 * __Jira Data Center logo__
 *
 * The Jira Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const JiraDataCenterLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewJiraDataCenterLogo);

/**
 * __Jira Service Management Data Center icon__
 *
 * The Jira Service Management Data Center icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const JiraServiceManagementDataCenterIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(
	NewJiraServiceManagementDataCenterIcon,
);
/**
 * __Jira Service Management Data Center logo__
 *
 * The Jira Service Management Data Center logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const JiraServiceManagementDataCenterLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(
	NewJiraServiceManagementDataCenterLogo,
);

/**
 * __Atlassian Administration icon__
 *
 * The Atlassian Administration icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AtlassianAdministrationIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyAtlassianAdministrationIcon,
	NewAdminIcon,
);

/**
 * __Atlassian Administration logo__
 *
 * The Atlassian Administration logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AtlassianAdministrationLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyAtlassianAdministrationLogo,
	NewAdminLogo,
);

/**
 * __Atlassian Admin icon__
 *
 * The Atlassian Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AtlassianAdminIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyAtlassianAdminIcon,
	NewAdminIcon,
);

/**
 * __Atlassian Admin logo__
 *
 * The Atlassian Admin logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AtlassianAdminLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyAtlassianAdminLogo,
	NewAdminLogo,
);

/**
 * __Atlassian Analytics icon__
 *
 * The Atlassian Analytics icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AtlassianAnalyticsIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyAtlassianAnalyticsIcon,
	NewAnalyticsIcon,
);
/**
 * __Atlassian Analytics logo__
 *
 * The Atlassian Analytics logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AtlassianAnalyticsLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyAtlassianAnalyticsLogo,
	NewAnalyticsLogo,
);

/**
 * __Bitbucket icon__
 *
 * The Bitbucket icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const BitbucketIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyBitbucketIcon,
	NewBitbucketIcon,
);
/**
 * __Bitbucket logo__
 *
 * The Bitbucket logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const BitbucketLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyBitbucketLogo,
	NewBitbucketLogo,
);
/**
 * __Compass icon__
 *
 * The Compass icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const CompassIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyCompassIcon,
	NewCompassIcon,
);
/**
 * __Compass logo__
 *
 * The Compass logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const CompassLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyCompassLogo,
	NewCompassLogo,
);
/**
 * __DX icon__
 *
 * The DX icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const DxIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewDXIcon);
/**
 * __Confluence icon__
 *
 * The Confluence icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const ConfluenceIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyConfluenceIcon,
	NewConfluenceIcon,
);
/**
 * __Confluence logo__
 *
 * The Confluence logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const ConfluenceLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyConfluenceLogo,
	NewConfluenceLogo,
);

/**
 * __Align icon__
 *
 * The Align icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AlignIcon: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAlignIcon);
/**
 * __Align logo__
 *
 * The Align logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const AlignLogo: ({ size, ...props }: import('./types').LogoProps) => React.JSX.Element =
	tempSizeWrapper(NewAlignLogo);

/**
 * __Jira Align icon__
 *
 * The Jira Align icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraAlignIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyJiraAlignIcon,
	NewAlignIcon,
);
/**
 * __Jira Align logo__
 *
 * The Jira Align logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraAlignLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyJiraAlignLogo,
	NewAlignLogo,
);

/**
 * __Jira icon__
 *
 * The Jira icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyJiraIcon,
	NewJiraIcon,
);
/**
 * __Jira logo__
 *
 * The Jira logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyJiraLogo,
	NewJiraLogo,
);
/**
 * __Jira product discovery icon__
 *
 * The Jira Product Discovery icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraProductDiscoveryIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyJPDIcon,
	NewJPDIcon,
);

/**
 * __Jira product discovery logo__
 *
 * The Jira Product Discovery logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraProductDiscoveryLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyJPDLogo,
	NewJPDLogo,
);

/**
 * __Jira service management icon__
 *
 * The Jira Service Management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraServiceManagementIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element =
	createFeatureFlaggedServiceCollectionComponent(LegacyJSMIcon, NewJSMIcon);

/**
 * __Jira service management logo__
 *
 * The Jira Service Management logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const JiraServiceManagementLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element =
	createFeatureFlaggedServiceCollectionComponent(LegacyJSMLogo, NewJSMLogo);

/**
 * __Loom icon__
 *
 * The Loom icon, in Teamwork Blue, without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const LoomIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyLoomIcon,
	NewLoomIcon,
);
/**
 * __Loom logo__
 *
 * The Loom logo, in Teamwork Blue, with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const LoomLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyLoomLogo,
	NewLoomLogo,
);
/**
 * __Loom Attribution icon__
 *
 * The Loom Attribution icon, in Teamwork Blue, without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const LoomAttributionIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyLoomAttributionIcon,
	NewLoomIcon,
);
/**
 * __Loom Attribution logo__
 *
 * The Loom Attribution logo, in Teamwork Blue, with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const LoomAttributionLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyLoomAttributionLogo,
	NewLoomAttributionLogo,
);
/**
 * __Loom (Blurple) logo__
 *
 * The Loom logo, in the Loom Blurple color, with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const LoomBlurpleLogo: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewLoomInternalLogo);
/**
 * __Loom (Blurple) icon__
 *
 * The Loom icon, in the Loom Blurple color, without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const LoomBlurpleIcon: ({
	size,
	...props
}: import('./types').LogoProps) => React.JSX.Element = tempSizeWrapper(NewLoomInternalIcon);
/**
 * __Opsgenie icon__
 *
 * The Opsgenie icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const OpsgenieIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element =
	createFeatureFlaggedServiceCollectionComponent(LegacyOpsgenieIcon, NewOpsgenieIcon);
/**
 * __Opsgenie logo__
 *
 * The Opsgenie logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const OpsgenieLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element =
	createFeatureFlaggedServiceCollectionComponent(LegacyOpsgenieLogo, NewOpsgenieLogo);

/**
 * __Statuspage icon__
 *
 * The Statuspage icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const StatuspageIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element =
	createFeatureFlaggedServiceCollectionComponent(LegacyStatuspageIcon, NewStatuspageIcon);
/**
 * __Statuspage logo__
 *
 * The Statuspage logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const StatuspageLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element =
	createFeatureFlaggedServiceCollectionComponent(LegacyStatuspageLogo, NewStatuspageLogo);
/**
 * __Trello icon__
 *
 * The Trello icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const TrelloIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyTrelloIcon,
	NewTrelloIcon,
);
/**
 * __Trello logo__
 *
 * The Trello logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const TrelloLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyTrelloLogo,
	NewTrelloLogo,
);
/**
 * __Rovo icon__
 *
 * The Rovo icon without an accompanying wordmark.
 *
 * By default, with no feature flags turned on, this will display a flat hex design.
 *
 * A colorful hex logo will render if:
 * 	- the feature flag `platform-logo-rebrand-rovo-hex` is set to true
 *  - the prop `shouldUseHexLogo` is set to true
 *
 * Finally, for backwards compatibility, if the prop `shouldUseNewLogoDesign` is set to true, or the following feature flags are set,
 * a tile will be rendered:
 * - `platform-logo-rebrand`
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const RovoIcon: ({
	shouldUseHexLogo,
	...props
}: import('./types').LogoProps & {
	shouldUseNewLogoDesign?: boolean;
	shouldUseHexLogo?: boolean;
}) => React.JSX.Element = createFeatureFlaggedRovoComponent(
	LegacyRovoIcon,
	NewRovoIcon,
	NewRovoHexIcon,
);
/**
 * __Rovo logo__
 *
 * The Rovo logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const RovoLogo: ({
	shouldUseHexLogo,
	...props
}: import('./types').LogoProps & {
	shouldUseNewLogoDesign?: boolean;
	shouldUseHexLogo?: boolean;
}) => React.JSX.Element = createFeatureFlaggedRovoComponent(
	LegacyRovoLogo,
	NewRovoLogo,
	NewRovoHexLogo,
);

/**
 * __Guard icon__
 *
 * The Guard icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const GuardIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyGuardIcon,
	NewGuardIcon,
);
/**
 * __Guard logo__
 *
 * The Guard logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const GuardLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyGuardLogo,
	NewGuardLogo,
);

/**
 * __Focus icon__
 *
 * The Focus icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const FocusIcon: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyFocusIcon,
	NewFocusIcon,
);
/**
 * __Focus logo__
 *
 * The Focus logo with both the wordmark and the icon combined.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export const FocusLogo: ({
	size,
	shouldUseNewLogoDesign,
	...props
}: import('./types').LogoProps) => React.JSX.Element = createFeatureFlaggedComponent(
	LegacyFocusLogo,
	NewFocusLogo,
);

export type { LogoProps } from './types';
